<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-university'></i> Receipt Account List</h3>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:cell(sn)="data">
                  {{data.index+1 + ((currentPage-1)*perPage)}}
                </template>
                <template v-slot:cell(status)="data">
                  <b-badge variant="success" v-if="data.item.status === 1">Enabled</b-badge>
                  <b-badge variant="warning" v-else-if="data.item.status === 2">Disabled</b-badge>
                </template>
                <template v-slot:cell(bankLogo)="data">
                  <img v-if="data.item.bankLogo !== ''" :src="`${data.item.bankLogo}`" alt="" width="75px">
                </template>
                <template v-slot:cell(qrCode)="data">
                  <img v-if="data.item.qrCode !== ''" :src="`${data.item.qrCode}`" alt="" width="75px">
                </template>
                <template v-slot:cell(Action)="data">
                  <b-btn v-if="checkAccessPrivilege('Payment.Bank.ReceiptAccount.Update')" @click="setSelectedData(data.item)" variant="info"><i class="icons icon-pencil"></i> </b-btn>
                </template>
              </b-table>
              <nav>
                <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <update-receipt-account :show-modal="showModal" :update-data="selectedData" @closeModal="closeModal" @updateData="$emit('updateData')" />
  </div>
</template>

<script>
import UpdateReceiptAccount from './UpdateReceiptAccount'

export default {
  name: 'ReceiptAccountList',
  components: {
    UpdateReceiptAccount
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fetching: false,
      type: 0,
      currentPage: 1,
      rowCount: 0,
      perPage: 20,
      selectedData: {},
      showModal: false
    }
  },
  methods: {
    getRowCount () {
      return this.rowCount
    },
    checkAccessPrivilege (module) {
      if (!module) return true
      return this.PRIVILEGE.includes(module)
    },
    setSelectedData (data) {
      this.selectedData = data
      this.showModal = true
    },
    closeModal () {
      this.selectedData = {}
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/payment/bank/ReceiptAccountTableDetail.vue